import statisricSeoKievTranslates from './statistic-seo-kiev-i18n.json';
import statisricSeoBrovaryTranslates from './statistic-seo-brovary-i18n.json';
import statisricSeoVyshgorodTranslates from './statistic-seo-vyshgorod-i18n.json';
import statisricSeoIrpenTranslates from './statistic-seo-irpen-i18n.json';

export default function () {
  return {
    ...statisricSeoKievTranslates,
    ...statisricSeoBrovaryTranslates,
    ...statisricSeoVyshgorodTranslates,
    ...statisricSeoIrpenTranslates,

    amountLC: {
      ru: 'Количество ЖК',
      ua: 'Кількість ЖК'
    },
    priceBeginText: {
      ru: 'от',
      ua: 'від'
    },
    green: {
      ru: 'Зеленый',
      ua: 'Зелений'
    },
    orange: {
      ru: 'Оранжевый',
      ua: 'Помаранчевий'
    },
    red: {
      ru: 'Красный',
      ua: 'Червоний'
    },
    shieldGreen: {
      ru: 'Зеленый щит',
      ua: 'Зелений щит'
    },
    shieldOrange: {
      ru: 'Оранжевый щит',
      ua: 'Помаранчевий щит'
    },
    shieldRed: {
      ru: 'Красный щит',
      ua: 'Червоний щит'
    },
    moreYear: {
      ru: 'более года',
      ua: 'понад рік'
    },
    moreThan2years: {
      ru: 'более 2-х лет',
      ua: 'більше 2-x років'
    },
    moreThan4years: {
      ru: 'более 4-х лет',
      ua: 'більше 4-x років'
    },
    typeApartment: {
      ru: 'Тип квартир',
      ua: 'Тип квартир'
    },
    pricePerSqMHousesUnderConstruction: {
      ru: 'Цена за кв. м в строящихся домах, грн',
      ua: 'Ціна за кв. м у будинках, які споруджують, грн'
    },
    pricePerSqMHousesFinished: {
      ru: 'Цена за кв. м в готовых домах, грн',
      ua: 'Ціна за кв. м у готових будинках, грн'
    },
    smart: {
      ru: 'Смарт',
      ua: 'Смарт'
    },
    studio: {
      ru: 'Студия',
      ua: 'Студія'
    },
    roomOne: {
      ru: 'Однокомнатная',
      ua: 'Однокімнатна'
    },
    roomTwo: {
      ru: 'Двухкомнатная',
      ua: 'Двокімнатна'
    },
    roomThree: {
      ru: 'Трехкомнатная',
      ua: 'Трикімнатна'
    },
    roomFour: {
      ru: 'Четырехкомнатная',
      ua: 'Чотирикімнатна'
    },
    roomFiveMore: {
      ru: 'Пятикомнатная и более',
      ua: 'П’ятикімнатна і більше'
    },
    tierTwo: {
      ru: 'Двухуровневая',
      ua: 'Дворівнева'
    },
    totalLCDforSale: {
      ru: 'Всего ЖК в продаже',
      ua: 'Всього ЖК у продажу'
    },
    ofThem: {
      ru: 'Из них:',
      ua: 'З них:'
    },
    underConstruction: {
      ru: 'строятся',
      ua: 'будуються'
    },
    classEconomy: {
      ru: '«Эконом»',
      ua: '«Економ»'
    },
    classComfort: {
      ru: '«Комфорт»',
      ua: '«Комфорт»'
    },
    classBusiness: {
      ru: '«Бизнес»',
      ua: '«Бізнес»'
    },
    classPremium: {
      ru: '«Премиум»',
      ua: '«Преміум»'
    },
    repairs: {
      ru: 'Ремонт',
      ua: 'Ремонт'
    },
    arrangementResidentialComplexes: {
      ru: 'Обустройство жилых комплексов',
      ua: 'Облаштування житлових комплексів'
    },
    withoutFinishing: {
      ru: 'Без отделки',
      ua: 'Без обробки'
    },
    forFinishing: {
      ru: 'Под чистовую отделку',
      ua: 'Під чистову обробку'
    },
    withoutFinishingOrRough: {
      ru: 'Без отделки либо/черновая отделка',
      ua: 'Без оздоблення або/ чорновим оздобленням'
    },
    renovatedFromDeveloper: {
      ru: 'С ремонтом от застройщика',
      ua: 'З ремонтом від забудовника'
    },
    heating: {
      ru: 'Отопление',
      ua: 'Опалення'
    },
    centralized: {
      ru: 'Централизованное',
      ua: 'Централізоване'
    },
    autonomousBoilerRoom: {
      ru: 'Автономная котельная',
      ua: 'Автономна котельня'
    },
    individual: {
      ru: 'Индивидуальное',
      ua: 'Індивідуальне'
    },
    concept: {
      ru: 'Концепция',
      ua: 'Концепція'
    },
    yardWithoutCars: {
      ru: 'Двор без машин',
      ua: 'Двір без машин'
    },
    cityWithinCity: {
      ru: 'Город в городе',
      ua: 'Місто в місті'
    },
    atWater: {
      ru: 'У воды',
      ua: 'Біля води'
    },
    operatedRoof: {
      ru: 'Эксплуатируемая крыша',
      ua: 'Експлуатований дах'
    },
    pantriesInHouse: {
      ru: 'Кладовые в доме',
      ua: 'Комори в будинку'
    },
    areasRecreationOnSite: {
      ru: 'Зоны отдыха на территории',
      ua: 'Зони відпочинку на території'
    },
    infrastructureParkingSecurity: {
      ru: 'Инфраструктура, парковка и безопасность',
      ua: 'Інфраструктура, парковка і безпека'
    },
    parkingUnderground: {
      ru: 'Подземная парковка',
      ua: 'Підземна парковка'
    },
    garageBoxes: {
      ru: 'Гаражные боксы',
      ua: 'Гаражні бокси'
    },
    closedArea: {
      ru: 'Закрытая территория',
      ua: 'Закрита територія'
    },
    parkOnTerritory: {
      ru: 'Парк на территории',
      ua: 'Парк на території'
    },
    result: {
      ru: 'Итоги:',
      ua: 'Підсумки:'
    },
  };
}
